import { DefaultStandWorksheetCalcService } from './stand-worksheet-calc.service.default';
import { StandWorksheetCalcServiceProvider } from './stand-worksheet-calc-service-provider';
import { StandWorksheetCalcServiceV2 } from './stand-worksheet-calc.service.v2';

export const SW_CALCULATION_SERVICES: any[] = [
  DefaultStandWorksheetCalcService,
  StandWorksheetCalcServiceV2,
];

export const SW_CALCULATION_SERVICE_PROVIDERS: any[] = [
  SW_CALCULATION_SERVICES,
  { provide: 'CalculationServices', useValue: SW_CALCULATION_SERVICES },
  StandWorksheetCalcServiceProvider,
];
